import { Button, Card, Grid } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { canMonitor } from '../commons/utils';
import { StarRateIcon } from '@mui/icons-material/StarRate';
import { Star } from '@material-ui/icons';


const ListraTramitesMovil = (props) => {

    const { data, openModalMovil, user, openDecisionModal, setModalBody, setModalTitle, setModalAccept, setModalCancel, setHideModalFields } = props

    const bgDark = { backgroundColor: 'rgb(0,0,0,0.04)', fontWeight: 'bold' }
    const txtStyle = { padding: 2, textAlign: "center", }
    const classes = useStyles();

    return (
        <div className={classes.cardContainer}>
            {data.map((item, index) => {
                return (
                    <Card style={{ marginBottom: 10, }} key={index}>
                        {canMonitor(user) && item.monitoreo ?
                            <Grid container style={{ backgroundColor: '#0064AC', color: 'white' }}>
                                <Grid item xs={10} pt={1} pl={7}>
                                    <p style={txtStyle}>Folio</p>
                                </Grid>
                                <Grid item xs={2} pt={1}>
                                    <Star style={{ color: '#edecd3' }} />
                                </Grid>

                            </Grid>
                            :
                            <div style={{ backgroundColor: '#0064AC', color: 'white' }}>
                                <p style={txtStyle}>Folio</p>
                            </div>
                        }
                        <div>
                            <p style={txtStyle}>{item.folio}</p>
                        </div>
                        <div style={bgDark}>
                            <p style={txtStyle}>Reclamante / Solicitante</p>
                        </div>
                        <div >
                            <p style={txtStyle}>{item.nombre_solicitante}</p>
                        </div>
                        <div style={bgDark}>
                            <p style={txtStyle}>Fecha Ingreso</p>
                        </div>
                        <div >
                            <p style={txtStyle}>{item.fecha_ingreso}</p>
                        </div>
                        <div style={bgDark}>
                            <p style={txtStyle}>Tipo de trámite</p>
                        </div>
                        <div >
                            <p style={txtStyle}>{item.tipo_reclamo}</p>
                        </div>
                        <div style={bgDark}>
                            <p style={txtStyle}>Entidad requerida</p>
                        </div>
                        <div >
                            <p style={txtStyle}>{item.reclamado}</p>
                        </div>
                        <div style={bgDark}>
                            <p style={txtStyle}>Etapa actual</p>
                        </div>

                        {item.fase !== null ?
                            <div >
                                <p style={txtStyle}>{item.fase.nombre}</p>
                            </div>
                            :
                            null
                        }

                        <div >
                            <Button style={{ width: '90%' }} variant='contained' onClick={() => {
                                openModalMovil(item)

                            }}>Ver</Button>
                        </div>
                        {canMonitor(user) ?
                            item.monitoreo ?
                                <div style={{ marginTop: 5 }} >
                                    <Button style={{ width: '90%' }} variant='contained' onClick={() => {
                                        setModalBody('¿Desea dejar de monitorear éste trámite?')
                                        setModalTitle('Monitorear trámite')
                                        setModalAccept('Dejar de monitorear')
                                        setModalCancel('Cancelar')
                                        setHideModalFields(true)
                                        openDecisionModal(item)

                                    }}>Dejar de monitorear</Button>
                                </div>
                                :
                                <div style={{ marginTop: 5 }} >
                                    <Button style={{ width: '90%' }} variant='contained' onClick={() => {
                                        setModalBody('¿Desea monitorear éste trámite?')
                                        setModalTitle('Monitorear trámite')
                                        setModalAccept('Monitorear')
                                        setModalCancel('Cancelar')
                                        setHideModalFields(false)
                                        openDecisionModal(item)

                                    }}>Monitorear</Button>
                                </div>
                            :
                            null
                        }
                        <br></br>
                    </Card>
                )
            })}
            <br></br>
        </div>
    );
}

export default ListraTramitesMovil;

const useStyles = makeStyles((theme) => ({
    cardContainer: {
        width: 'inherit',
        minWidth: '100%',
        margin: 0,
        padding: 0,
        marginBottom: 10
    },
}));

